// Global
import React from 'react';

// Local
import styles from './Preamble.module.scss';
import { CtaFields, HeadlineFields } from 'lib/types/headlineFields';
import clsx from 'clsx';

export type PreambleOrientation = 'TopLeft' | 'TopCenter' | 'SideLeft';

export interface PreambleProps extends HeadlineFields, CtaFields, React.PropsWithChildren {
  align?: PreambleOrientation;
  headingId?: string | null;
}

export const Preamble = (props: PreambleProps) => {
  const alignmentClass =
    props.align === 'TopCenter' ? styles.preambleAlignCenter : styles.preambleAlignLeft;

  if (
    !props.headline &&
    !props.headlineIcon &&
    !props.headlineEyebrow &&
    !props.headlineSubhead &&
    !props.headlineDescription &&
    !props.cta1 &&
    !props.cta2
  ) {
    return props.children;
  }

  const hasHeadlineTitles = !!props.headline || !!props.headlineSubhead;
  const hasTopCopy =
    props.headline ||
    props.headlineIcon ||
    props.headlineEyebrow ||
    props.headlineSubhead ||
    props.headlineDescription;
  const hasCta = props.cta1 || props.cta2;
  return (
    <div
      className={clsx(styles.preambleWrapper, {
        [styles.preambleWrapper_SideLeft]: props.align === 'SideLeft',
      })}
    >
      <div
        className={clsx(styles.preamble, alignmentClass, {
          [styles.preambleAlignCenterForSideLeft]: props.align === 'SideLeft',
        })}
      >
        <div
          className={clsx(styles.preambleCopyContainer, {
            [styles.preambleCopySideLeft]: props.align === 'SideLeft',
          })}
        >
          {hasTopCopy && (
            <div className={styles.preambleCopy}>
              {props.headlineIcon && (
                <div className={styles.preambleHeadlineIconContainer}>
                  <div className={styles.preambleHeadlineIcon}>{props.headlineIcon}</div>
                </div>
              )}
              {props.headlineEyebrow && (
                <div className={styles.preambleHeadlineEyebrow}>{props.headlineEyebrow}</div>
              )}
              {hasHeadlineTitles && (
                <div className={styles.preambleHeadlineTitlesContainer}>
                  {props.headline && (
                    <h2 className={styles.preambleHeadlineText} id={props.headingId ?? undefined}>
                      {props.headline}
                    </h2>
                  )}
                  {props.headlineSubhead && (
                    <div className={styles.preambleHeadlineSubhead}>{props.headlineSubhead}</div>
                  )}
                </div>
              )}
              {props.headlineDescription && (
                <div className={styles.preambleHeadlineDescription}>
                  {props.headlineDescription}
                </div>
              )}
            </div>
          )}

          {hasCta && (
            <div
              className={clsx(styles.preambleCta, {
                [styles.preambleCtaSideLeft]: props.align === 'SideLeft',
                [styles.preambleCtaCenter]: props.align === 'TopCenter',
              })}
            >
              {props.cta1 && props.cta1}
              {props.cta2 && props.cta2}
            </div>
          )}
        </div>
      </div>
      {/* Empty div to prevent the flex layout from applying to the children in case 
      of multiple child elements */}
      <div className={clsx({ [styles.rightContainerMain]: props.align === 'SideLeft' })}>
        {props.children}
      </div>
    </div>
  );
};
